export default {
  siteName: "CSSBuy Spreadsheet",
  tagline: "O Guia Completo para Comprar da China",
  navHome: "Início",
  navGuide: "Guia",
  navArticles: "Artigos",
  navStartHere: "Comece Aqui",
  btnCssbuySpreadsheet: "CSSBuy Spreadsheet",
  btnBuyNow: "Comprar Agora",
  btnAccessGuide: "Acessar Guia Completo",
  btnViewComparison: "Ver Comparação de Produtos",
  btnStartBuying: "Começar a Comprar Agora",
  btnReadArticle: "Ler Artigo Completo",
  btnBackHome: "← Voltar ao Início",
  heroTitle1: "CSSBuy Spreadsheet",
  heroTitle2: "O Guia Completo para Comprar",
  heroTitle3: "da China com Segurança",
  heroDesc: "Planilhas organizadas com os melhores produtos da China. Economize dinheiro, encontre qualidade e evite golpes.",
  sectionCategories: "Categorias de Produtos",
  sectionCategoriesDesc: "Explore nossas planilhas organizadas por categoria e encontre exatamente o que procura",
  sectionAbout: "Por que usar CSSBuy Spreadsheet?",
  sectionAboutDesc: "Usar spreadsheets permite que você economize dinheiro comparando preços reais, encontre produtos de melhor qualidade, evite vendedores ruins ou scams e acesse produtos exclusivos da China com mais segurança.",
  sectionComparison: "Exemplo de Comparação de Produtos",
  sectionFAQ: "Perguntas Frequentes",
  sectionArticles: "Artigos e Guias",
  sectionArticlesDesc: "Aprenda tudo sobre como comprar da China com segurança e economia",
  faqQ1: "CSSBuy Spreadsheet é seguro?",
  faqA1: "Sim, mas depende de como você usa. Pagamentos são protegidos, há fotos reais dos produtos, verificação antes do envio e suporte de agente. Recomendamos sempre usar nossos guias para evitar erros com taxas de importação e prazos de entrega.",
  faqQ2: "Como funciona o CSSBuy Spreadsheet?",
  faqA2: "É simples: escolha uma categoria na planilha, compare produtos usando nossa tabela, clique no produto desejado, use o CSSBuy como agente de compra e receba em casa com segurança.",
  faqQ3: "Quanto tempo demora a entrega?",
  faqA3: "O tempo de entrega internacional varia entre 7 a 30 dias, dependendo do método de envio escolhido e do país de destino. Recomendamos verificar as opções disponíveis antes de finalizar a compra.",
  faqQ4: "Preciso pagar taxas de importação?",
  faqA4: "Depende do país de destino e do valor da compra. Em Portugal e na União Europeia, compras acima de determinado valor podem estar sujeitas a taxas alfandegárias. Consulte a legislação local.",
  faqQ5: "Posso devolver um produto?",
  faqA5: "As políticas de devolução variam conforme o vendedor. O CSSBuy oferece verificação de qualidade antes do envio, o que reduz significativamente a necessidade de devoluções.",
  warningTitle: "Aviso Importante",
  warningText: "Este site é um guia informativo independente sobre CSSBuy Spreadsheet. Não vendemos produtos diretamente. Sempre recomendamos verificar fornecedores antes de comprar.",
  footerRights: "© 2026 CSSBuy Spreadsheet. Todos os direitos reservados.",
  footerTerms: "Termos de Uso",
  footerPrivacy: "Privacidade",
  footerContact: "Contato",
  articleTitle: "CSSBuy Spreadsheet: O Guia Definitivo para Comprar da China",
  categorySelect: "Selecione uma categoria",
  allCategories: "Todas as Categorias",
}